import { doHttp } from '../util/common'
import { HTTP_TYPE_GET, HTTP_TYPE_POST } from '../util/constants'

/**
 * 添加文件接口，将上传的文件添加到文件柜中
 * @param params
 * @returns {*}
 */
export function apiAddFile (params = {}) {
  params.fileType = 1
  return doHttp('/fileCabinet/v1/authApi/addFile', HTTP_TYPE_POST, params)
}

/**
 * 获取我的文件列表接口，仅文件是自己上传的才能获取。
 * @returns {*}
 */
export function apiOwnFileList(page, rows) {
  let params = {
    page,
    rows
  }
  return doHttp('/fileCabinet/v1/authApi/getOwnFileList', HTTP_TYPE_POST, params)
}

/**
 * 删除文件接口，将文件柜中的文件删除，同时会删除文件与贸易的关联，并且物理删除服务器上的文件。参数为文件柜中文件的主键id
 * @param id
 * @returns {*}
 */
export function apiDeleteFile (id) {
  let params = {
    id
  }
  return doHttp('/fileCabinet/v1/authApi/deleteFile', HTTP_TYPE_POST, params)
}

/**
 * 通过贸易附件列表中的主键id删除贸易中关联的附件。
 * @param id
 * @returns {*}
 */
export function apiDeleteTradeFileById (id) {
  let params = {
    id
  }
  return doHttp('/fileCabinet/v1/authApi/deleteTradeFileById', HTTP_TYPE_POST, params)
}

/**
 * 获取贸易中的附件列表接口
 * @param params
 * @returns {*}
 */
export function apiTradeFileList (params) {
  return doHttp('/fileCabinet/v1/getTradeFileList', HTTP_TYPE_POST, params)
}

/**
 * 获取指定贸易可以关联的文件列表接口，当一个文件关联了某个贸易后，将不会再出现在这个贸易的可关联文件列表中。
 * @param params
 * @returns {*}
 */
export function apiTradeFileListAddible (params) {
  return doHttp('/fileCabinet/v1/authApi/getTradeFileListAddible', HTTP_TYPE_POST, params)
}

/**
 * 将文件柜中的文件关联到贸易中
 * @param params
 * @returns {*}
 */
export function apiAddTradeFile (fileId, tradeId) {
  let params = {
    fileId,
    tradeId
  }
  return doHttp('/fileCabinet/v1/authApi/addTradeFile', HTTP_TYPE_POST, params)
}



// WEBPACK FOOTER //
// ./src/api/file.js